import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import { GET_LOT_SIZING_CRITERIA_KEY, GET_LOT_SIZING_KEY } from '@/keys';

const refreshCriteria = async (lotSizingId: string): Promise<void> => {
  await api.post(`/lot-sizings/${lotSizingId}/criteria/refresh`);
};

export const useRefreshCriteria = (): UseMutationResult<
  void,
  Error,
  string
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: refreshCriteria,
    onSuccess: (_, lotSizingId) => {
      queryClient.invalidateQueries({
        queryKey: [...GET_LOT_SIZING_CRITERIA_KEY, lotSizingId],
      });
      queryClient.invalidateQueries({
        queryKey: [...GET_LOT_SIZING_KEY, lotSizingId],
      });
    },
  });
};
